import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useIsDas_tech(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isDas_tech = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;
    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    const protocol = Iv_list.iv_protocol?.[index] || "";
    return ["Das_tech"].includes(protocol);
  }, [Iv_list, SelInverter]);

  return isDas_tech;
}

